import { useFavorites, type FavType } from "@/hooks/useFavorites";
import { shareContent } from "@/utils/share";
import { showToast } from "@/components/base/Toast";

interface DetailActionsProps {
  type: FavType;
  id: string;
  title: string;
  path: string;
}

export default function DetailActions({ type, id, title, path }: DetailActionsProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const fav = isFavorite(type, id);

  const handleToggle = () => {
    const added = toggleFavorite({ type, id, title });
    showToast(added ? "已加入收藏（保存在本地）" : "已取消收藏", added ? "ri-heart-fill" : "ri-heart-line");
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <button
        type="button"
        onClick={handleToggle}
        className={`flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition ${
          fav
            ? "bg-secondary-500 text-background-50 hover:bg-secondary-600"
            : "border border-background-300 text-foreground-700 hover:border-secondary-400 hover:text-secondary-700"
        }`}
      >
        <i className={fav ? "ri-heart-fill text-lg" : "ri-heart-line text-lg"}></i>
        {fav ? "已收藏" : "收藏"}
      </button>
      <button
        type="button"
        onClick={() => shareContent(title, path)}
        className="flex items-center gap-2 rounded-full border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition hover:border-accent-400 hover:text-accent-700"
      >
        <i className="ri-share-forward-line text-lg"></i>
        分享
      </button>
      <span className="text-xs text-foreground-400">收藏保存于浏览器本地（演示）</span>
    </div>
  );
}